module.exports = __webpack_public_path__ + "img/Rule_box_title.7f7c30f8.png";